
    <!--
 * 竖版-盲盒抽奖
 * @LastEditTime: Sat Sep 14 2024 18:08:17 GMT+0800 (中国标准时间)
 -->
 <template>
  <div id="u_c_9LBP81"  :class="[`normal`,`u_c_9LBP81`]" ><div id="u_c_5OC382"  v-html="compData.title" :class="[`${ compData.title ? 'text' : '' }`,`normal`,`u_c_5OC382`]" ></div><div id="u_c_F9RS83"  v-html="compData.subTitle" :class="[`normal`,`u_c_F9RS83`]" ></div><div id="u_c_I4TP84"  :class="[`normal`,`u_c_I4TP84`]" ><span id="u_c_KSJG85"  :class="[`normal txt`,`u_c_KSJG85`]" >{{`${ langData.myCoupon }:`}}</span><span id="u_c_KFON87"  :class="[`normal txt count`,`u_c_KFON87`]" >{{`${ pageData.couponCount }`}}</span><a id="u_c_6JTI89" href="javascript:;" :class="[`normal txt`,`u_c_6JTI89`]" @click="u_c_6JTI89_event_MAWI24($event)">{{`[${ langData.checkGiftBtn }]`}}</a><a id="u_c_BIPC91" href="javascript:;" :class="[`normal txt`,`u_c_BIPC91`]" @click="u_c_BIPC91_event_MAWI24($event)">{{`[${ langData.refresh }]`}}</a></div><div id="u_c_JQ4E93"  :class="[`normal`,`u_c_JQ4E93`]" ><div id="u_c_D14494"  v-for="(giftItem, giftI) in compData.boxList" :key="giftI" :class="[`normal`,`u_c_D14494`]" ><div id="u_c_6R6I95"  :style="`background-image:url(${ compData.giftPic })`" :class="[`${ giftItem.cur ? 'light' : '' }`,`normal`,`u_c_6R6I95`]" ></div></div></div><div id="u_c_BZWR96"  :class="[`normal`,`u_c_BZWR96`]" ><a id="u_c_9LYG97" href="javascript:;" :style="`background-image:url(${ pageData['common-btn-bg'] })`" v-if="!bridge.runInsdk()" :class="[`normal btn-light `,`u_c_9LYG97`]" @click="u_c_9LYG97_event_MAWI24($event)"><div id="u_c_BJCH98"  :class="[`normal page-common-btn`,`u_c_BJCH98`]" >{{`${ langData.gotoStoreBtn }`}}</div></a><a id="u_c_17K2100" href="javascript:;" :style="`background-image:url(${ pageData['lottery-btn-bg'] })`" :class="[`${ compData.canClick ? 'btn-light' : '' }`,`normal  `,`u_c_17K2100`]" @click="u_c_17K2100_event_334420($event)"><div id="u_c_3NGB101"  v-show="!(compData.is10 && pageData.couponCount >= 10)" :class="[`normal page-common-btn`,`u_c_3NGB101`]" >{{`${ compData.canClick ? langData.lotteryBtn : langData.inLottery }`}}</div><div id="u_c_5VHQ103"  v-show="compData.is10 && pageData.couponCount >= 10" :class="[`normal page-common-btn`,`u_c_5VHQ103`]" >{{`${ compData.canClick ? langData.lottery10 : langData.inLottery }`}}</div></a></div></div>
  </template>
<script setup>
import {reactive,provide,inject,onMounted,watch,watchEffect,ref,computed,nextTick,readonly,toRaw,markRaw} from "vue";
import * as vueUse from "@vueuse/core";
import Language from "@/hooks/language.js";
import Router from "@/hooks/router.js";
import bridge from "@/utils/sdkBridge.js";
import { useRoute } from 'vue-router';
import * as request from "@/api/request";
import * as utils from "@/utils";
import * as _ from "lodash-es";


    const { curLang, getLangTxt,langData } = Language();
    const routerData = inject("routerData",{});
    const pageData = inject("pageData", {});
    const COMP_DATA_LANG = {"default":{"subTitle":`活动期间，通过官网储值日储值满5美金，每日可获得3次机会开启盲盒`,"lotteryList":[{"name":"袜子1","pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/02/16754189607104.png"},{"name":"袜子2","pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/02/1675418960122.png"},{"name":"袜子3","pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/02/16754189606833.png"}],"giftPic":`https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1722417498353-74.png`,"boxList":[{cur:1},{cur:0},{cur:0}],"canClick":true,"title":`天使的选择
盲盒活动`,"is10":true},"zh-TW":{"subTitle":`活動期間，通過【官網儲值頁面】任意管道儲值，累計儲值金額每次達到100TWD，都會獲得一張抽獎券；`,"lotteryList":[{"name":"元寶*50","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/08/172250344800645775.png"},{"name":"急速行軍*5","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/08/172250344822381607.png"},{"name":"點將令*5","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/08/172250344869042620.png"},{"name":"兵種技錦囊*10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/08/172250344848505874.png"},{"name":"高級輜重箱*2","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/08/172250344815124502.png"},{"name":"黃金沙漏*2","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/08/172250344875410755.png"},{"name":"洗煉隨機箱*50","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/08/172250344882928535.png"},{"name":"兵法集錄*10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/08/172250344880633778.png"},{"name":"英雄技錦囊*30","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/08/172250618091150062.png"}],"giftPic":`https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1722417498353-74.png`,"boxList":[{cur:1},{cur:0},{cur:0}],"canClick":true,"title":`中秋賞月禮包`,"is10":true}};
    const compData = reactive(COMP_DATA_LANG[curLang] || COMP_DATA_LANG['zh-TW']||{});
    let pagePlatform = "global"
    const router = Router();
    const route = useRoute();

    // 自定义setup - 开始
    const checkIsBind = inject("checkIsBind", () => {})
const checkIsLogin = inject("checkIsLogin", () => {})
const initActivity = inject("initActivity", () => {})
const showTips = inject("showTips", (txt, code) => {})
const showGetSucc = inject("showGetSucc", (type, pic, name) => {})
const listData = inject("listData", {})
const canClickRefresh = inject("canClickRefresh", true)
const giftInfo = inject("giftInfo", {})
const getCurLink = inject("getCurLink", (link) => {})

const curPlatform = pagePlatform

watch(
  () => listData,
  (value) => {
    if (value && value.lotteryList) {
      let confList = _.cloneDeep(compData.lotteryList)
      compData.lotteryList = []
      value.lotteryList.forEach((item, index) => {
        if (confList[index]) {
          compData.lotteryList.push({
            state: pageData.lotteryType == "no_reset" ? item.send_status : 0,
            id: item.id,
            name: confList[index].name,
            pic: confList[index].pic,
            cur: index ? 1 : 0,
          })
        }
      })
      giftInfo.lotteryAward = compData.lotteryList
    }
  }, {
    deep: true
  }
)

const init = () => {
  compData.canClick = true
  compData.storeLink = getCurLink(compData.storeLink)
  compData.boxList.forEach((item, index) => {
    item.cur = index ? 0 : 1
  })
}

init()

const getGiftName = (data) => {
  let name = ""
  if (data.send_type == "sendSerial") {
    name = `${langData.giftCode}：${data.send_value}`
  } else {
    let curId = compData.lotteryList.findIndex((item) => item.id == data.id)
    if (~curId) {
      name = compData.lotteryList[curId].name
    }
  }

  return name
}

const excLottery = async () => {
  let isMutiple = compData.is10 && pageData.couponCount >= 10
  let res = await excLotteryAjax(isMutiple)
  if (res.result != 1) {
    showTips(getLangTxt(res.code, getLangTxt("common")), res.code)
    return
  }

  let curGiftType = isMutiple ? "sendVt" : res.data.send_type
  let curGiftPic = isMutiple ? "" : compData.giftPic
  let curGiftName = ""
  let curUse = 0

  if (isMutiple) {
    for (let i in res.data) {
      if (res.data[i].id != 0) {
        curUse++
        curGiftName += `${getGiftName(res.data[i])}<br/><br/>`
      }
    }
    if (curUse < 10) {
      curGiftName = `${curGiftName}${langData.lottery10error.replace(
        /{{n}}/,
        String(curUse)
      )}`
    }
  } else {
    curGiftName = getGiftName(res.data)
  }

  let currentUse = isMutiple ? curUse : 1

  pageData.couponCount = +pageData.couponCount - currentUse
  pageData.lotteryTime = +pageData.lotteryTime + currentUse

  showGetSucc(curGiftType, curGiftPic, curGiftName)
}

const excLotteryAjax = async (isMutiple) => {
  let curAction = isMutiple ? "batchLotteryAward" : "lotteryAward"
  let res = await request.getJSON(utils.getActivityApi(pagePlatform, pageData.pageId, curAction), {
    params: JSON.stringify({
      language: curLang,
    }),
  })
  return res
}

// 盲盒轮闪
const TIMER = 500
let latestTime = new Date().getTime()
const updateLight = () => {
  let nowTime = new Date().getTime()
  if (nowTime - latestTime > TIMER) {
    latestTime = nowTime
    let latestIndex = compData.boxList.findIndex((item) => item.cur == 1)
    if (~latestIndex) {
      compData.boxList[latestIndex].cur = 0
      let nextIndex =
        latestIndex == compData.boxList.length - 1 ? 0 : latestIndex + 1
      compData.boxList[nextIndex].cur = 1
    }
  }
  window.requestAnimationFrame(updateLight)
}
updateLight();
      // 查看奖励按钮的click事件
      const u_c_6JTI89_event_MAWI24= async (e)=>{
        try {let arr = [];
compData.lotteryList.forEach(item=>{
  arr.push({
    name:item.name,
    pic:item.pic
  })
})
pageData.seeGift = arr;
pageData.seeGiftPopupState = true;} catch (error) {console.log(error)}
      };
      // 更新按钮的click事件
      const u_c_BIPC91_event_MAWI24= async (e)=>{
        try {if (!checkIsLogin()) return
if (!checkIsBind()) return
if(!canClickRefresh.value)return;
canClickRefresh.value = false;
initActivity();
await utils.sleep(5);
canClickRefresh.value = true;} catch (error) {console.log(error)}
      };
      // 去充钱的click事件
      const u_c_9LYG97_event_MAWI24= async (e)=>{
        try {window.activityDataLayer.push({
  eventName: 'click_button',
  eventType: '前往储值',
  gameId: pageData.gameId,
  aid: pageData.pageId,
});
bridge.open(pageData.storeLink)
} catch (error) {console.log(error)}
      };
      // 抽奖按钮的click事件
      const u_c_17K2100_event_334420= async (e)=>{
        try {if (!checkIsLogin()) return
if (!checkIsBind()) return
if (!compData.canClick) return
compData.canClick = false
window.activityDataLayer.push({
  eventName: "click_button",
  eventType: "点击抽奖",
  gameId: pageData.gameId,
  aid: pageData.pageId,
})
await excLottery()
compData.canClick = true} catch (error) {console.log(error)}
      }
    // 自定义setup - 结束


</script>
<style lang="scss" scoped>
.default{
.u_c_9LBP81.normal{
position:relative;
width:10.00rem;
height:14.27rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1726307207835-76.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}

.u_c_9LBP81.normal .txt{
font-size:0.29rem;
color:#ffffff;

}

.u_c_9LBP81.normal .count{
color:#ffe3b2;
font-weight:bold;

}

.u_c_9LBP81.normal .light{
transition:all .1s;
filter:brightness(1.5);

}
}.default{
.u_c_5OC382.normal{
position:relative;
width:14.91rem;
height:1.44rem;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:0.65rem;
font-size:0.93rem;
color:#fedb2a;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_5OC382.normal.text{
width:100%;
height:auto;

}
}.default{
.u_c_F9RS83.normal{
position:relative;
margin-top:0.57rem;
line-height:1.5;
box-sizing:border-box;
padding:0 0.27rem;
font-size:0.29rem;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;

}
}.default{
.u_c_I4TP84.normal{
position:relative;
text-align:center;
margin-top:0.43rem;
display:flex;
justify-content:center;
align-items:center;

}
}.default{
.u_c_KSJG85.normal{
position:relative;
font-size:0.37rem;
color:#ffffff;

}
}.default{
.u_c_KFON87.normal{
position:relative;
margin-left:0.13rem;

}
}.default{
.u_c_6JTI89.normal{
position:relative;
margin-left:2.67rem;

}
}.default{
.u_c_BIPC91.normal{
position:relative;
margin-left:0.67rem;

}
}.default{
.u_c_JQ4E93.normal{
position:relative;
margin:auto;
margin-top:0.85rem;
display:flex;
justify-content:space-between;
align-items:center;
font-size:0;
align-content:center;
width:9.33rem;

}
}.default{
.u_c_D14494.normal{
position:relative;

}
}.default{
.u_c_6R6I95.normal{
position:relative;
background:no-repeat center;
background-size:contain;
width:2.41rem;
height:3.32rem;

}
}.default{
.u_c_BZWR96.normal{
position:relative;
margin:auto;
margin-top:0.59rem;
display:flex;
justify-content:center;
align-items:center;

}
}.default{
.u_c_9LYG97.normal{
position:relative;
width:5.36rem;
height:2.77rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709850744352.png);
display:block;
overflow:hidden;
text-decoration:none;
margin:auto 0.20rem;

}
}.default{
.u_c_BJCH98.normal{
position:relative;
text-align:center;
margin-top:0.91rem;

}
}.default{
.u_c_17K2100.normal{
position:relative;
width:5.36rem;
height:2.77rem;
display:block;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16710946022767.png);
overflow:hidden;
text-decoration:none;
margin:auto 0.20rem;

}
}.default{
.u_c_3NGB101.normal{
position:relative;
text-align:center;
margin-top:0.89rem;

}
}.default{
.u_c_5VHQ103.normal{
position:relative;
text-align:center;
margin-top:0.92rem;

}
}.zh-TW{
.u_c_9LBP81.normal{
position:relative;
width:10.00rem;
height:14.27rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1726307207835-76.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}

.u_c_9LBP81.normal .txt{
font-size:0.29rem;
color:#ffffff;

}

.u_c_9LBP81.normal .count{
color:#ffe3b2;
font-weight:bold;

}

.u_c_9LBP81.normal .light{
transition:all .1s;
filter:brightness(1.5);

}
}.zh-TW{
.u_c_5OC382.normal{
position:relative;
width:14.91rem;
height:1.44rem;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:0.65rem;
font-size:0.93rem;
color:#fedb2a;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_5OC382.normal.text{
width:100%;
height:auto;

}
}.zh-TW{
.u_c_F9RS83.normal{
position:relative;
margin-top:0.57rem;
line-height:1.5;
box-sizing:border-box;
padding:0 0.27rem;
font-size:0.29rem;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;

}
}.zh-TW{
.u_c_I4TP84.normal{
position:relative;
text-align:center;
margin-top:0.43rem;
display:flex;
justify-content:center;
align-items:center;

}
}.zh-TW{
.u_c_KSJG85.normal{
position:relative;
font-size:0.37rem;
color:#ffffff;

}
}.zh-TW{
.u_c_KFON87.normal{
position:relative;
margin-left:0.13rem;

}
}.zh-TW{
.u_c_6JTI89.normal{
position:relative;
margin-left:2.67rem;

}
}.zh-TW{
.u_c_BIPC91.normal{
position:relative;
margin-left:0.67rem;

}
}.zh-TW{
.u_c_JQ4E93.normal{
position:relative;
margin:auto;
margin-top:0.85rem;
display:flex;
justify-content:space-between;
align-items:center;
font-size:0;
align-content:center;
width:9.33rem;

}
}.zh-TW{
.u_c_D14494.normal{
position:relative;

}
}.zh-TW{
.u_c_6R6I95.normal{
position:relative;
background:no-repeat center;
background-size:contain;
width:2.41rem;
height:3.32rem;

}
}.zh-TW{
.u_c_BZWR96.normal{
position:relative;
margin:auto;
margin-top:0.59rem;
display:flex;
justify-content:center;
align-items:center;

}
}.zh-TW{
.u_c_9LYG97.normal{
position:relative;
width:5.36rem;
height:2.77rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709850744352.png);
display:block;
overflow:hidden;
text-decoration:none;
margin:auto 0.20rem;

}
}.zh-TW{
.u_c_BJCH98.normal{
position:relative;
text-align:center;
margin-top:0.91rem;

}
}.zh-TW{
.u_c_17K2100.normal{
position:relative;
width:5.36rem;
height:2.77rem;
display:block;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16710946022767.png);
overflow:hidden;
text-decoration:none;
margin:auto 0.20rem;

}
}.zh-TW{
.u_c_3NGB101.normal{
position:relative;
text-align:center;
margin-top:0.89rem;

}
}.zh-TW{
.u_c_5VHQ103.normal{
position:relative;
text-align:center;
margin-top:0.92rem;

}
}
</style>
